import {Box, Text, Image, Heading, Flex, Center} from '@chakra-ui/react';
import * as React from 'react';
import {SlideInBox} from './slide-in-box';

export const ArtWithPurpose: React.FC = () => {
  return (
    <Center mb="100px">
      <Box w="100%" maxW="1080" px="20px">
        <Flex
          position="relative"
          overflow="hidden"
          flexDirection={{base: 'column', md: 'row'}}
          alignItems="center"
        >
          <Box
            w={{base: '100%', md: '50%', lg: '40%'}}
            pr={{base: 0, md: '30px'}}
            mb={{base: '20px', sm: '40px', md: 0}}
          >
            <SlideInBox>
              <Heading fontSize={{base: '25px', md: '36px'}} zIndex={5}>
                Art with
              </Heading>
            </SlideInBox>
            <SlideInBox>
              <Heading
                color="aqua.700"
                zIndex={5}
                fontSize={{base: '40px', md: '60px'}}
              >
                Purpose
              </Heading>
            </SlideInBox>
            <Text mt={{base: '10px', md: '20px'}}>
              Banksy’s work has always served the purpose of commenting on
              social and political issues worldwide to raise awareness, and
              Valentine’s Day Mascara is no different. We are asking for
              donations in aid of Refuge, the nation’s largest domestic abuse
              organisation.
            </Text>
          </Box>
          <Box
            w={{base: '100%', md: '50%', lg: '60%'}}
            pl={{base: 0, md: '30px'}}
          >
            <Image
              src="/assets/banksy/banksy-tripple-picture.png"
              alt="banksy valentines day mascara"
              maxWidth="100%"
              margin="0 auto"
            />
          </Box>
        </Flex>
      </Box>
    </Center>
  );
};
